module.exports = __webpack_public_path__ + "img/renliziyuan.54ea4f43.png";